import { Component, OnInit, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

import { Onix } from '../../../models/Onix';
import { BookService } from './../../../services/book.service';

@Component({
  selector: 'app-onix-selector',
  templateUrl: './onix-selector.component.html',
  styleUrls: ['./onix-selector.component.css'],
  providers: [
    BookService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => OnixSelectorComponent),
      multi: true
    }
  ]
})
export class OnixSelectorComponent implements OnInit {

  items: Observable<any[]>;
  selected: Onix;
  loading: boolean;

  @Input() list: string;
  @Input() default: Onix;
  @Input() placeholder: string;
  @Input() required: boolean = false;
  @Output() notify: EventEmitter<Onix> = new EventEmitter<Onix>();

  @Input() eraseable: boolean;
  @Output() removeNotify: EventEmitter<any> = new EventEmitter<any>();


  constructor(private bookService: BookService) { }

  onChange(e: Onix) {
    this.notify.emit(e)
    this.propagateChange(e);
    // console.log('onChange', e)
  }

  compareWithFn = function(o1: Onix, o2: Onix) {
    let match = o1 && o2 ? o1.value == o2.value : false;
    if (match) {
      if (this.notify) {
        this.notify.emit(o1);
      }
    }
    return match;
  }.bind(this);

  ngOnInit() {
    this.loading = true;
    this.items = this.readItems(this.list)
      .map(result => {
        this.loading = false;
        if (result.success) {
          return result.items;
        }
      })
  }

  eraseMe() {
    this.removeNotify.emit();
  }

  private propagateChange = (_: any) => { };

  private readItems(list: string): Observable<any> {
    switch (list) {
      case 'tax':
        return this.bookService.readTax();
      case 'packaging':
        return this.bookService.readPackaging();
      case 'argomenti': //deprecato - sono troppi - usato un selector
        return this.bookService.readArgomenti();
      case 'audience':
        return this.bookService.readAudience();
      default:
        return this.bookService.readOnix(this.list);
    }
  }

  public writeValue(obj: Onix) {
    // if(this.placeholder=='ruolo')
    //   console.log('======= ************ writeValue', this.placeholder, obj)

    if (obj) {
      this.selected = new Onix({
        value: obj.value,
        label: obj.label,
        etichetta: obj.etichetta
      })
    }
    // else if (this.default) {
    //   this.selected = this.default;
    //   this.propagateChange(this.selected);
    // }
    // this.propagateChange(this.selected);
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() { }
}



// WEBPACK FOOTER //
// ./src/app/components/onix/onix-selector/onix-selector.component.ts